export default function Container({ 
    children,
    direction = "vertical",
    gap = "1rem",
    // use with caution
    overrides
}) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: direction === "vertical" ? "column" : "row",
                flexWrap: direction === "vertical" ? "nowrap" : "wrap",
                gap: gap,
                padding: "1rem",
                ...overrides
            }}
        >
            {children}
        </div>
    )
}